// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"155":"4fa17736","173":"44af12f8","269":"49ac2a8c","395":"83bb4b3c","579":"d9b68d6e","812":"311483e8","822":"22616ad1","828":"595ea6d1","875":"66ac4086","890":"90265106"}[chunkId] + ".js";
};